module.exports = __webpack_public_path__ + "static/Statutory-Compliance-6cc2248031f28471fb44748f488bcd20.png";